<template>
  <v-card flat class="pa-4" style="background: transparent;">
    <v-row no-gutters class="pa-6">
      <v-col cols="12" class="mb-4">
        <v-row no-gutters>
          <p class="subheading mb-0 mr-2">
            <strong>{{ $t('username') }}:</strong>
          </p>
          <span>{{ username }}</span>
        </v-row>
      </v-col>

      <v-col cols="12" class="mb-2">
        <v-row no-gutters>
          <v-icon v-if="operator" size="22" class="mr-2">
            check
          </v-icon>
          <v-icon v-else size="22" class="mr-2">
            clear
          </v-icon>
          <p class="subheading mb-0">
            <strong>{{ $t('is_operator') }}</strong>
          </p>
        </v-row>
      </v-col>
      <v-col cols="12" class="mb-2">
        <v-row no-gutters>
          <v-icon v-if="mxn" size="22" class="mr-2">
            check
          </v-icon>
          <v-icon v-else size="22" class="mr-2">
            clear
          </v-icon>
          <p class="subheading mb-0">
            <strong>{{ $t('mxn_enabled') }}</strong>
          </p>
        </v-row>

        <v-row
          no-gutters
          class="ml-8"
          v-if="mxn"
        >
          <p class="subheading mb-0 mr-2">
            <strong>{{ `- ${$tc('nsauth_state')}` }}:</strong>
          </p>
          <span>{{ permissionState }}</span>
        </v-row>

        <v-row
          no-gutters
          class="ml-8"
          v-if="mxn"
        >
          <p class="subheading mb-0 mr-2">
            <strong>{{ `- ${$tc('nsauth_permissions')}` }}:</strong>
          </p>
          <span>{{ permissionList }}</span>
        </v-row>
      </v-col>

      <v-col cols="12" class="mb-2">
        <v-row no-gutters>
          <v-icon v-if="tfa" size="22" class="mr-2">
            check
          </v-icon>
          <v-icon v-else size="22" class="mr-2">
            clear
          </v-icon>
          <p class="subheading mb-0">
            <strong>{{ $t('tfa_enabled') }}</strong>
          </p>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
const STATE_UNKNOWN = 0
const STATE_ABSENT = 1
const STATE_NULL = 2
const STATE_ASSOCIATED = 3
const STATE_AUTHORIZED = 4

// const NSAUTH_ACL_OBJ_DEL = 0x00000000 + 1
// const NSAUTH_ACL_OBJ_OPEN = NSAUTH_ACL_OBJ_DEL << 1
// const NSAUTH_ACL_OBJ_EXPORT = NSAUTH_ACL_OBJ_DEL << 2
// const NSAUTH_ACL_OBJ_BLOCK = NSAUTH_ACL_OBJ_DEL << 3
// const NSAUTH_ACL_NS_DEL = NSAUTH_ACL_OBJ_DEL << 4

export default {
  data () {
    return {
      operator: false,
      mxn: false,
      tfa: false,
      permissionState: '',
      permissionStateValue: 0,
      permissionList: []
    }
  },
  async created () {
    this.setPermissions()

    await this.getPermissionState(this.username)
  },
  computed: {
    acl () {
      return this.$store.state.auth.acl
    },
    username () {
      return this.$store.state.auth.username
    }
  },
  methods: {
    setPermissions () {
      const perm = this.$store.getters['auth/getPermissions']

      this.operator = perm.isOperator
      this.mxn = perm.isUserNSAuthorization
      this.tfa = perm.isUserToken
    },
    async getPermissionState (user) {
      const nsauth = await this.$store.dispatch('hsm/getNsAuth', { body: { usr: user } })
      let permissionState = ''

      switch (nsauth.state) {
        case STATE_UNKNOWN:
          permissionState = this.$tc('nsauth_unknown')
          break

        case STATE_ABSENT:
          permissionState = this.$tc('nsauth_absent')
          break

        case STATE_NULL:
          permissionState = this.$tc('nsauth_null')
          break

        case STATE_ASSOCIATED:
          permissionState = this.$tc('nsauth_associated')
          break

        case STATE_AUTHORIZED:
          permissionState = this.$tc('nsauth_authorized')
          break

        default:
          permissionState = this.$tc('nsauth_unknown')
          break
      }

      this.permissionState = permissionState
      this.permissionStateValue = nsauth.state
      this.getPermissions(nsauth.mask)
    },
    getPermissions (mask) {
      const permissionOptions = {
        1: this.$tc('nsauth_key_destroy', 2),
        2: this.$tc('nsauth_key_read', 2),
        4: this.$tc('nsauth_key_export', 2),
        8: this.$tc('nsauth_key_block', 2),
        16: this.$tc('nsauth_partition_remove', 2)
      }

      const permList = Object.keys(permissionOptions)
        .filter(item => mask & item)
        .map(item => permissionOptions[item])

      if (permList.length === 0) {
        this.permissionList = ''
      } else if (permList.length === 1) {
        this.permissionList = permList[0]
      } else {
        const last = permList.pop()
        this.permissionList = permList.join(', ') + ' e ' + last
      }
    }
  },
  watch: {
    acl () {
      this.setPermissions()
    }
  },
  beforeMount () {
    this.permissionState = ''
    this.permissionStateValue = 0
    this.permissionList = []
  }
}
</script>
